module.exports = __webpack_public_path__ + "img/messages-bubble-square-alternate.39f26b07.svg";